<template>
  <div class="card d-print-none mb-2">
    <div class="card-body">
      <router-link :to="taskData.api_url" class="mr-2 mb-2 btn btn-sm bg-gradient-primary" ><i class="feather icon-corner-up-left"></i> {{labels.get('label_back')}}</router-link>
    </div>
  </div>
  <div class="card d-print-none mb-2" v-if="item.exists">
    <div class="card-header">
      <div>{{labels.get('label_details_task')}} ({{item.id}})</div>
    </div>
    <div class="card-body">
        <DetailTemplate :detailFields="item.detailFields" />
    </div>
  </div>
</template>
<script setup>


  import toastFunctions from "@/assets/toastFunctions";
  import labels from '@/labels'
  
  import {useRouter} from "vue-router";
  import {inject, reactive} from "vue";
  import axios from "axios";
  import DetailTemplate from '@/components/DetailTemplate.vue';
  import {useRoute} from "vue-router/dist/vue-router";
  import systemFunctions from "@/assets/systemFunctions";


  const route =useRoute()
  const router =useRouter()
  let taskData = inject('taskData')
  let item=reactive({
    id:0,
    exists:false,
    detailFields:{},
    data:{
    }
  })
  const setDetailFields=async ()=>{
    item.detailFields= {};
    await systemFunctions.delay(1);
    let detailFields={}
    let key='id';
    detailFields[key] = {
      label: labels.get('label_'+key),
      type:'hidden',
      values:[item.data[key]],
    };
    key='name';
    detailFields[key] = {
      label: labels.get('label_'+key),
      type:'text',
      values:[item.data[key]],
    };
    key='address';
    detailFields[key] = {
      label: labels.get('label_'+key),
      type:'text',
      values:[item.data[key]],
    };
    key='phone_number';
    detailFields[key] = {
      label: labels.get('label_'+key),
      type:'text',
      values:[item.data[key]],
    };
    key='zip_code';
    detailFields[key] = {
      label: labels.get('label_'+key),
      type:'text',
      values:[item.data[key]],
    };
    key='name_contact_1';
    detailFields[key] = {
      label: 'Contact 1 Name',
      type:'text',
      values:[item.data[key]],
    };
    key='phone_contact_1';
    detailFields[key] = {
      label: 'Contact 1 Phone',
      type:'text',
      values:[item.data[key]],
    };
    key='email_contact_1';
    detailFields[key] = {
      label: 'Contact 1 Email',
      type:'text',
      values:[item.data[key]],
    };
    key='name_contact_2';
    detailFields[key] = {
      label: 'Contact 2 Name',
      type:'text',
      values:[item.data[key]],
    };
    key='phone_contact_2';
    detailFields[key] = {
      label: 'Contact 2 Phone',
      type:'text',
      values:[item.data[key]],
    };
    key='email_contact_2';
    detailFields[key] = {
      label: 'Contact 2 Email',
      type:'text',
      values:[item.data[key]],
    };
    key='name_contact_3';
    detailFields[key] = {
      label: 'Contact 3 Name',
      type:'text',
      values:[item.data[key]],
    };
    key='phone_contact_3';
    detailFields[key] = {
      label: 'Contact 3 Phone',
      type:'text',
      values:[item.data[key]],
    };
    key='email_contact_3';
    detailFields[key] = {
      label: 'Contact 3 Email',
      type:'text',
      values:[item.data[key]],
    };
    item.detailFields=detailFields;
  }
  const getItem=async ()=>{
    await axios.get(taskData.api_url+'/get-item/'+ item.id).then((res)=>{
      if (res.data.error == "") {
        item.data=res.data.item;
        setDetailFields();
        item.exists=true;
      }
      else{
        toastFunctions.showResponseError(res.data)
      }
    });
  }
  item.id=route.params['item_id'];
  getItem();

</script>